module.exports = __webpack_public_path__ + "static/media/silkscreen.c97b1177.eot";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/SilkScreen/silkscreen.eot
// module id = 22
// module chunks = 0